import type { Dict } from '@/helpers';
import type League from '@/models/league';
import type { leagueMember } from '@/models/user';
import {
  getJoinOrderRank,
  isPendingLeagueRank,
  isSettledLeagueRank,
  memberHasList,
} from '@/helpers/leagues/leagueMemberSync';

function memberDisplayName(member: leagueMember): string {
  return member.name?.trim() ? member.name.trim() : 'Anonymous';
}

function memberRankLabel(league: League, member: leagueMember, uid: string): string {
  if (isSettledLeagueRank(member.currentRank)) {
    return String(member.currentRank);
  }
  if (isPendingLeagueRank(member.currentRank)) {
    return '—';
  }
  return String(getJoinOrderRank(league, member, uid));
}

function memberPointsLabel(member: leagueMember, tournamentStarted: boolean): string {
  if (!memberHasList(member)) {
    return '—';
  }
  return tournamentStarted ? String(member.currentScore ?? 0) : '0';
}

/** Plain-text league standings for clipboard share (one line per list-holding member). */
export function formatLeagueStandingsCopyText(
  league: League,
  membersByUid: Dict<leagueMember>,
  memberUidsInOrder: string[],
  options: { tournamentStarted: boolean },
): string {
  return memberUidsInOrder
    .filter((uid) => memberHasList(membersByUid[uid]))
    .map(
      (uid) =>
        `${memberDisplayName(membersByUid[uid])} - Rank: ${memberRankLabel(league, membersByUid[uid], uid)} - Points: ${memberPointsLabel(membersByUid[uid], options.tournamentStarted)}`,
    )
    .join('\n');
}
